import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getImplantPreferenceDefaults } from "../implantPreferenceForm";

const FRAMEWORKS = [
  "Barre Ackermann (Co-Cr)",
  "Armature titane",
  "Armature zircone",
];
const TEETH_MATERIALS = ["Résine", "Composite", "Zircone"];
const FALSE_GINGIVA = ["Claire", "Foncée", "Rouge", "Sans"];

export const AllOnPreferences = withForm({
  defaultValues: getImplantPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "allOnFramework",
      "allOnTeethMaterial",
      "falseGingiva",
    ]);

    return (
      <SaveableCard
        title="All-on"
        description="Armature et dents"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Armature par défaut</Text>
              <form.Field name="allOnFramework">
                {field => (
                  <Select
                    data={FRAMEWORKS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Matériau des dents</Text>
              <form.Field name="allOnTeethMaterial">
                {field => (
                  <Select
                    data={TEETH_MATERIALS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Text variant="strong">Fausse gencive</Text>
            <form.Field name="falseGingiva">
              {field => (
                <Group>
                  {FALSE_GINGIVA.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
